// Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useAuth } from './AuthProvider';
import SubmitNewPassword from './SubmitNewPassword';
import PasswordInput from './components/PasswordInput';
import ShowErrorMsg from './components/ShowErrorMsg';
import FormOpenAccount from './FormOpenAccount';
import { useConfig } from './ConfigHolder';
import FirstTimeLangSelection from './FirstTimeLangSelection';
import {ErrorCatcher, getErrorMessage} from './components/ErrorCatcher';
import EnableAccount from './EnableAccount';
import { formatDate } from './generalUtils';
import OnPlanEndErrorHandler from './OnPlanEndErrorHandler';
import Header from './Header';
import Footer from './Footer';

const HandleError = ({error, errorMsg, errorCode,
                      onSendConfirmation,
                      onSuccessfulPasswordReset,
                      email,
                      onEnableAccountSuccess: parentOnEnableAccountSuccess }) => {
  // const [showSubmitNewPassword, setShowSubmitNewPassword] = useState(false);
  const [freeTrialExpirationDate, setFreeTrialExpirationDate] = useState(null);
 
  // local fallback if parent didn't provide a handler
  const localOnEnableAccountSuccess = (expDate) => {
    console.log('onEnableAccountSuccess called from Error Handler, expDate=', expDate);
    const fDate = formatDate(expDate);
    setFreeTrialExpirationDate(fDate);
  }

  const handleOnSendConfirmationClick = async () => {
    onSendConfirmation();
  };


  if (errorCode && (errorCode === 4001) ){    
 
    return (
      <Box>
        {/* {!showSubmitNewPassword && <ShowErrorMsg error={errorMsg} />} */}
        {/* <Typography
          variant="body2"
          color="primary"
          sx={{ fontStyle: "italic", textDecoration: "underline", cursor: "pointer" }}
          onClick={() => {setShowSubmitNewPassword(true);
                          
          }}
        >
          Forgot password?
        </Typography> */}
        {/* {showSubmitNewPassword && (
          <SubmitNewPassword onPasswordChange={onSuccessfulPasswordReset} email={email} />
        )} */}
      </Box>
    )
  } else if ( errorCode && ([5020, 5002].includes(errorCode))) 
  {
    return (
      <Box>
        <ShowErrorMsg error={errorMsg} />
        <Button
          variant="outlined"
          color="primary"
          onClick={handleOnSendConfirmationClick}
          sx={{ mt: 2 }}
        >
          Send Confirmation
        </Button>
      </Box>
    )
  } else if (errorCode && (errorCode === 4030)) { // first time, no account yet

    return (
      <Box>
  { !freeTrialExpirationDate ? (
  <EnableAccount email = {email}
      introMessage={()=>{}}
      onEnableAccountSuccess={parentOnEnableAccountSuccess || localOnEnableAccountSuccess}
  >
  </EnableAccount> ) : 
        (
          <Typography>You successfully started the free trial which expires on {freeTrialExpirationDate}. 
          Please, login to your account.
          </Typography>
        )}
      </Box>
    )

  } else if (errorCode && [4032, 4033, 4100].includes(errorCode)) {
    console.log('Rendering OnPlanEndErrorHandler from HandleError, errorCode=', errorCode);
    return (
      <OnPlanEndErrorHandler
        errorCode={errorCode}
        error={error}
        freeTrialExpirationDate={freeTrialExpirationDate}
        onEnableAccountSuccess={parentOnEnableAccountSuccess || localOnEnableAccountSuccess}
      />
    );
  } else {
    // return null;
    return <ShowErrorMsg error={errorMsg} />
  }
};

const Login = ({ callBackShutDownMessage }) => {
  const { login, send_confirmation} = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorCode, setErrorCode] = useState(null);
  const [showLoginButton, setShowLoginButton] = useState(true);
  const [showSignUp, setShowSignUp] = useState(false);
  const [confirmOK, setConfirmOK] = useState("")
  // const [confirmOK, setConfirmOK] = useState(' or <span style="color:red; font-weight:bold;">SPAM folder</span> and click the link. </br> After that, please, Login again.')

  const { getConfigCloud, updateConfig, config } = useConfig();
  const [showFirstTime, setShowFirstTime] = useState(false);
  const [errorObj, setErrorObj] = useState(null);
  const [showEnableAccount, setShowEnableAccount] = useState(false);
  const [trialExpirationDate, setTrialExpirationDate] = useState(null);
  const [showSubmitNewPassword, setShowSubmitNewPassword] = useState(false);

  useEffect(() => {
    // Check for session expired flag
    const expired = localStorage.getItem('sessionExpired');
    console.log("expired", expired);
    if (expired === "true") {
      try {
        throw new Error("Your session expired. Please login again")
      } catch (error)
      {
        setErrorObj(error);
        setErrorMsg("Session expired, please login")
        // localStorage.setItem('sessionExpired', 'false'); // Set session expired flag
      }

    }
 
  }, []);

  useEffect(() => {
    if (callBackShutDownMessage) {
    callBackShutDownMessage('Email confirmation sent. Close this tab and click the link in your email');
    }
  }, [callBackShutDownMessage]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrorMsg(null);
    setShowLoginButton(true);
    setShowSignUp(false);
    setCredentials((prevCredentials) => ({ ...prevCredentials, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg(null);
    setConfirmOK("");

    // Trim email and password
    const trimmedCredentials = {
      email: credentials.email.trim(),
      password: credentials.password ? credentials.password.trim() : ''
    };

    try {
      const res = await login(trimmedCredentials);
      
      if (res) {
        const cfg = await getConfigCloud();
        console.log('from login', cfg);
        localStorage.setItem('sessionExpired', 'false'); // Set session expired flag

        if (cfg?.firstTime?.mainPage) {
          setShowFirstTime(true);
        } else {
          setShowFirstTime(false);
          navigate('/main');
        }
      }
    } catch (error) {
      setShowSignUp(false);
      setErrorObj(error);
      const { msg, code } = getErrorMessage(error);
      setErrorCode(code);
      // If this is a plan-end / expired-trial type error, render EnableAccount directly here
      // instead of delegating to OnPlanEndErrorHandler. That avoids nested dialog/portal
      // re-mount cycles which were preventing the PayPal iframe from stabilizing.
      // if ([4032, 4033, 4100].includes(code)) {
       if ([].includes(code)) {
        setShowEnableAccount(true);
        setErrorMsg(null); // avoid rendering HandleError which would delegate again
      } else {
        if ([4030, 4032, 4033, 4100].includes(code)) {
          setShowLoginButton(false);
        } 
        setErrorMsg(msg);
      }
      
    }
  };

  const handleFirstTimeClose = () => {
    setShowFirstTime(false);
    const ft = config['firstTime']
    ft['mainPage'] = false;
    updateConfig('firstTime', ft);
    // config.firstTime.mainPage = false;

    navigate('/main');
  }

  const handleSendConfirmation = async () => {
    setShowLoginButton(false);
    setConfirmOK("");
    setErrorMsg(null);
    const email = credentials.email;
    if (email) {
      try {
        let res_confirmation = await send_confirmation(email);
        // Update the message with HTML markup for "SPAM folder":
        let conf_message = `${res_confirmation} Please, find an email from speaknoaccents.com in your inbox </br>` + 
        ' or <span style="color:red; font-weight:bold;">SPAM folder</span> and click the link. After that, please, Login again.';
        setConfirmOK(conf_message);
        setShowLoginButton(true);
      } catch {
        setErrorMsg('Failed to send confirmation. Try again');
      }
    }
  };

  const handleSuccessfulPasswordReset = (pw) => {
    setErrorMsg(null);
    setCredentials((prevCredentials) => ({ ...prevCredentials, password: pw }));
    setShowLoginButton(true);
    setShowSubmitNewPassword(false);
 
  };

  const onSignUpSuccess = (creds) => {
    setCredentials(creds);
    setErrorMsg(null);
    setShowLoginButton(true);
  }

  const onEnableAccountSuccess = async (expDate) => {
    console.log('onEnableAccountSuccess called, credentials=', credentials);
    // Try to log the user in automatically using current credentials
    try {
      const trimmedCredentials = {
        email: (credentials.email || '').trim(),
        password: (credentials.password || '').trim(),
      };

      // Only attempt login if we have both email and password
      if (trimmedCredentials.email && trimmedCredentials.password) {
        const res = await login(trimmedCredentials);
        if (res) {
          // Logged in successfully — fetch config and navigate as in handleSubmit
          const cfg = await getConfigCloud();
          localStorage.setItem('sessionExpired', 'false');
          if (cfg?.firstTime?.mainPage) {
            setShowFirstTime(true);
          } else {
            setShowFirstTime(false);
            navigate('/main');
          }
          return;
        }
      }
    } catch (err) {
      // login failed — fall through to show confirmation message
      console.warn('Automatic login after free trial failed', err);
    }

    // Fallback behavior: show confirmation/message to user
  setTrialExpirationDate(expDate);
    setShowEnableAccount(false);
    setShowLoginButton(true);
    setConfirmOK("");
  }
 
  return (
    <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              // alignItems: 'flex-start', 
              // alignItems: 'center',
              mt: 0, 
              ml: 1,
              mr: 1,
              // minHeight: 0,
              minHeight: '100dvh',
              // maxHeight: 'calc(100vh - 300px)',
              width: '100%',
              boxSizing: 'border-box',
              paddingTop: 'env(safe-area-inset-top)',
              paddingBottom: 'env(safe-area-inset-bottom)',
            }}
            >

            {/* Modal for session expiration */}
    <Header />

      <Box 
        component="form" 
        onSubmit={handleSubmit} 
        sx={{ display: 'flex', 
              flexDirection: 'column', 
              width: '70%' , 
              // mt:4, 
              // mx:'auto',
              }}>
        { showLoginButton && ( <>
        <Box sx={{ mb: 2 }}>
          <TextField
            type="email"
            id="email"
            name="email"
            label="Email"
            value={credentials.email}
            onChange={handleInputChange}
            required
            autoComplete="email"
            fullWidth
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '1.0rem', // This sets the input text size
              },
            }}
            inputProps={{ autoCapitalize: "none" }} // Prevents mobile auto-capitalization
          />
        </Box>
        <Box sx={{ mb: 2, width: '100%' }}>
          { !showSubmitNewPassword && <PasswordInput
            name="password"
            id="password"
            value={credentials.password}
            onChange={handleInputChange}
            placeholder="Enter password"
          />
          }
        </Box> </>)}
        <Box>
          {errorMsg  && (
            <Box>
            <HandleError
              error = {errorObj}
              errorMsg={errorMsg}
              errorCode = {errorCode}
              onSendConfirmation={handleSendConfirmation}
              onSuccessfulPasswordReset={handleSuccessfulPasswordReset}
              email={credentials.email}
              onEnableAccountSuccess={onEnableAccountSuccess}
            />
            {![4030,4032, 4033, 4100].includes(errorCode) && (<ErrorCatcher error = {errorObj}
                          callBackMapOpen ={{"Network Error": () => {setShowLoginButton(true)},
                             "4001": () => {},
                             "4022": () => {setShowSignUp(true)}
                            }}
                          resetError={()=>{setErrorObj(null)}}
                          autoHideDuration={10000}
                          clickAwayExit={false}
               position = {{ vertical: 'top', horizontal: 'center' }}
            ></ErrorCatcher>)}
            </Box>
           )  
        } 
           { (showLoginButton && !showSignUp) ? (
              <Box sx = {{
                // display: 'flex',
                // alignItems: 'flex-end',
                // gap: 2,
                mt:2,
                }}>
                {confirmOK && (
                  <Typography sx={{ mb:2 }} dangerouslySetInnerHTML={{ __html: confirmOK }} />
                )}
              <Box sx={{ display: 'flex', 
                // alignItems: 'flex-end', 
                gap: 2, 
                mt: 2, 
                flexWrap: 'wrap' 
                }}>
  { ! showSubmitNewPassword &&  <Button type="submit" variant="contained" color="primary">
    Login
  </Button>
  }

  <Button
    variant="outlined"
    color="primary"
    sx={{
      ml: { xs: 2, sm: 4, md: 8 }, // responsive horizontal spacing
      mt: 0,                      // no top margin so bottoms align
      alignSelf: 'flex-end',       // force this button to align with bottom of the row
      borderRadius: '15px'
    }}
    onClick={() => {
      setShowSubmitNewPassword(!showSubmitNewPassword);
    }}
  >
    {!showSubmitNewPassword ? "Forgot Password?" : "Back to Login"}
  </Button>
</Box>
              {showSubmitNewPassword && (
                <SubmitNewPassword onPasswordChange={handleSuccessfulPasswordReset} email={credentials.email} />
              )}


              </Box>

            ) : ( (!showSignUp && !showEnableAccount)  && 
              <Typography variant="body2" color="textSecondary">
                
              </Typography>
            )
           }
          <Box sx={{ mr: 4, mt:4 }}>
            { showSignUp && <FormOpenAccount onSuccess = {onSignUpSuccess}
                                             email = {credentials.email}
                                             password = {credentials.password} 
            
            /> }
          </Box>
          {showEnableAccount && <EnableAccount email = {credentials.email}
                                  introMessage = { () => (<Typography>To complete the signup</Typography>)}
                                  onEnableAccountSuccess = { onEnableAccountSuccess}

          ></EnableAccount>}
          {trialExpirationDate && (<Box>
            <Typography>You have successfully signed up for a free trial!</Typography>
            <Typography>It will expire on {trialExpirationDate} </Typography>
            <Typography>Please, login </Typography>
          </Box>)}
        </Box>
      </Box>
      { showFirstTime &&
      <FirstTimeLangSelection open = {showFirstTime} onClose = {handleFirstTimeClose} /> }
      <Box sx={{ flexGrow: 1 }} />
      <Footer sx={{ mt: 'auto' }} />
    </Box>
  )
};

export default Login;